import { useClaims, useHasPermission } from "../auth/useClaims";

// Fuel.* codes (they sit on the VEHICLES module server-side). These booleans
// only decide what to SHOW - the server remains the authority, e.g. approving
// your own refill additionally needs Admin.SelfApproval there.
//
// The two any-of lists mirror the API's own OfficeRead / TransactionRead
// policies, and are what the routes and the menu gate on.
export const FUEL_OFFICE_READ = [
  "Fuel.ManageCards",
  "Fuel.CreateRefill",
  "Fuel.ApproveRefill",
  "Fuel.ViewAllTransactions",
  "Fuel.ReviewExceptions",
  "Fuel.ViewReports",
];
export const FUEL_TRANSACTION_READ = [
  "Fuel.ViewTransactions",
  "Fuel.ViewAllTransactions",
  "Fuel.ReviewExceptions",
  "Fuel.ViewReports",
];
// GET /fuel/refills' own policy - Fuel.ManageCards alone does NOT read refills.
export const FUEL_REFILL_READ = ["Fuel.CreateRefill", "Fuel.ApproveRefill", "Fuel.ViewReports"];
export const FUEL_EXCEPTIONS_READ = ["Fuel.ReviewExceptions", "Fuel.ViewAllTransactions", "Fuel.ViewReports"];

export const useCanManageFuelCards = () => useHasPermission("Fuel.ManageCards");
export const useCanCreateFuelRefill = () => useHasPermission("Fuel.CreateRefill");
export const useCanApproveFuelRefill = () => useHasPermission("Fuel.ApproveRefill");
export const useCanReviewFuelExceptions = () => useHasPermission("Fuel.ReviewExceptions");
export const useCanViewFuelReports = () => useHasPermission("Fuel.ViewReports");
export const useCanSelfApprove = () => useHasPermission("Admin.SelfApproval");

const useHasAny = (codes) => {
  const { permissions } = useClaims();
  return codes.some((c) => permissions.includes(c));
};

// The card / vehicle / user lookups are OfficeRead endpoints - a driver who
// only holds Fuel.ViewTransactions can open the transactions list but would
// get a 403 from the filter dropdowns, so those queries are skipped for them.
export const useCanReadFuelOffice = () => useHasAny(FUEL_OFFICE_READ);

// The server returns only the caller's OWN purchases unless they hold one of
// these - used to tell the user which of the two they are looking at.
export const useSeesAllFuelTransactions = () =>
  useHasAny(["Fuel.ViewAllTransactions", "Fuel.ReviewExceptions", "Fuel.ViewReports"]);
